import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import {
  parseYearSlug,
  parseMonthSlug,
  parseDateSlug,
  MONTH_SLUGS_ID,
} from "@/lib/calendar/dates";

/**
 * Legacy root-level calendar URLs (e.g. `/2026`, `/juni-2026`, `/7-juni-2026`)
 * have been moved under `/kalender/...`. This route 308-redirects any of
 * those slugs to their new canonical home and 404s anything else.
 */
export const Route = createFileRoute("/$slug")({
  loader: ({ params }) => {
    const slug = params.slug;
    const y = parseYearSlug(slug);
    if (y !== null) {
      throw redirect({ to: `/kalender/${y}/`, code: 308 } as any);
    }
    const ym = parseMonthSlug(slug);
    if (ym) {
      throw redirect({ to: `/kalender/${ym.y}/${MONTH_SLUGS_ID[ym.m - 1]}/`, code: 308 } as any);
    }
    const ymd = parseDateSlug(slug);
    if (ymd) {
      throw redirect({ to: `/kalender/${ymd.y}/${ymd.d}-${MONTH_SLUGS_ID[ymd.m - 1]}/`, code: 308 } as any);
    }
    throw notFound();
  },
  component: () => null,
  notFoundComponent: () => (
    <SiteShell>
      <div className="py-16 text-center">
        <h1 className="text-2xl font-bold">Halaman tidak ditemukan</h1>
        <p className="mt-2 text-muted-foreground">
          URL ini tidak cocok dengan format yang valid.
        </p>
      </div>
    </SiteShell>
  ),
});